import domtoimage from "dom-to-image"
import { saveAs } from "file-saver"
import { jsPDF } from "jspdf"

export const getScreenshotPageBlobFromNodeId = nodeId => {
  return new Promise(resolve => {
    const doc = document.getElementById(nodeId)
    domtoimage.toBlob(doc).then(function (blob) {
      resolve(blob)
    })
  })
}

export function downloadScreenShotFile(nodeId, fileName) {
  const name = fileName !== "" ? fileName : "export"

  getScreenshotPageBlobFromNodeId(nodeId).then(aScreenshotBlob => {
    saveAs(aScreenshotBlob, `${name}.png`)
  })
}

export function blobToFile(aBlob, fileName) {
  if (aBlob) {
    aBlob.lastModifiedDate = new Date()
    aBlob.name = fileName
  }

  return aBlob
}

export function getScreenShotFile(nodeId, fileName) {
  const name = fileName !== "" ? fileName : "export"
  return getScreenshotPageBlobFromNodeId(nodeId).then(aScreenshotBlob => {
    return blobToFile(aScreenshotBlob, name)
  })
}

export function blobToBase64(blob) {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result)
    }
  })
}

export function getScreenShotBase64(nodeId) {
  return getScreenshotPageBlobFromNodeId(nodeId).then(blob => {
    return blobToBase64(blob).then(result => result)
  })
}

export function getImgInPDF(nodeId, fileName = "") {
  const name = fileName !== "" ? fileName : "export"

  getScreenShotBase64(nodeId).then(base64Screenshot => {
    var doc = new jsPDF()
    var imgData = base64Screenshot
    doc.addImage(imgData, "png", 15, 40, 180, 160)
    doc.save(`${name}.pdf`)
  })
}
